import React from 'react'
import { Text } from 'grommet'
import { I18n } from 'galarm-config'
import Constants from 'galarm-config/src/Constants.web'

const OrganizationRoleInfo = ({ organizationName, userRoles }) => {
  // Convert role codes to human-readable strings
  const getRoleDisplayName = role => {
    switch (role) {
      case Constants.ENTERPRISE_USER_ROLES.OWNER:
        return I18n.t('owner')
      case Constants.ENTERPRISE_USER_ROLES.ADMIN:
        return I18n.t('admin')
      case Constants.ENTERPRISE_USER_ROLES.VIEWER:
        return I18n.t('viewer')
      case Constants.ENTERPRISE_USER_ROLES.ACCOUNT_MANAGER:
        return I18n.t('accountManager')
      case Constants.ENTERPRISE_USER_ROLES.INCIDENT_COORDINATOR:
        return I18n.t('incidentCoordinator')
      default:
        return role
    }
  }

  const humanReadableRoles = userRoles
    .map(role => getRoleDisplayName(role))
    .join(', ')

  return (
    <Text
      alignSelf="start"
      color="lightTint"
      size="small"
      weight={500}
      margin="small"
      style={{ whiteSpace: 'pre-line' }}>
      {I18n.t('loggedIntoOrganizationAccount', {
        organizationName,
        role: humanReadableRoles
      })}
    </Text>
  )
}

export default OrganizationRoleInfo
